<mdb-progress-bar [class.hidden]="!operations.loadTeamDetails.busy"
                  mode="indeterminate"></mdb-progress-bar>
<ng-container *ngIf="team">
  <header>

    <chapps-header [label]="team.label"></chapps-header>
    <i (click)="showEditNameDialog()"
       class="fa fa-lg clickable fa-pencil-alt"
       id="editNameButton"></i>
    <div>
      <input (ngModelChange)="toggleAutoAccept($event)"
             [(ngModel)]="team.isAutoAccept"
             id="autoAcceptsJobsField"
             type="checkbox"/>
      <label for="autoAcceptsJobsField">
        {{ Localization.AutoSend | translate }}
      </label>

    </div>
    <i *ngIf="cannotDeleteTeam"
       [matTooltip]="reasonWhyTeamCannotBeDeleted | translate"
       class="fa fa-question-circle grey-text fa-lg"></i>

    <chapps-danger-button (click)="delete()"
                          [disabled]="cannotDeleteTeam"
                          [label]="Localization.Delete | translate"
                          [small]="true"></chapps-danger-button>
  </header>
  <main>
    <section class="contacts">
      <hgroup>
        <h3 [translate]="Localization.Contacts" class="title"></h3>
        <chapps-select-input [control]="contactSelectionField"
                             [items]="availableContacts"
                             [loading]="operations.loadContacts.busy"
                             [placeholder]="Localization.SelectContact"
        ></chapps-select-input>
        <chapps-primary-button (click)="addSelectedContact()"
                               [disabled]="!contactSelectionField.value"
                               [label]="Localization.AddContact"
                               [outline]="true"
                               [small]="true"
                               icon="fa-plus"></chapps-primary-button>
        <chapps-primary-button (click)="addNewContact()"
                               [label]="Localization.CreateNewContact"
                               [outline]="true"
                               [small]="true"
                               icon="fa-plus"></chapps-primary-button>

      </hgroup>
      <table class="table table-striped table-hover details-table">
        <thead>
        <tr>
          <th [translate]="Localization.FirstName"></th>
          <th [translate]="Localization.LastName"></th>
          <th [translate]="Localization.Email"></th>
          <th [translate]="Localization.Phone"></th>
          <th [translate]="Localization.Status"></th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr (click)="show(contact)"
            *ngFor="let contact of team.assignedContacts"
            class="clickable">
          <td>{{ contact.firstName }}</td>
          <td>{{ contact.lastName}}</td>
          <td>{{ contact.email }}</td>
          <td>{{ contact.phone }}</td>
          <td>

            <!-- @Todo: port translation-->
            <chapps-primary-button (click)="invite(contact, $event)"
                                   [class.hidden]="confirmed(contact)"
                                   [disabled]="!canInvite(contact)"
                                   [label]="'Invite'"
                                   [outline]="true"
                                   [small]="true"
            ></chapps-primary-button>
          </td>
          <td class="controls">
            <i (click)="removeFromTeam(contact, $event)"
               class="fas fa-trash text-danger"></i>
          </td>
        </tr>
        </tbody>
      </table>
    </section>

    <section class="buildings">
      <hgroup>
        <h3 class="title">Buildings</h3>

        <div>
          <input (ngModelChange)="toggleLinkedToAllBuildings($event)"
                 [(ngModel)]="team.isLinkedToAllBuildings"
                 id="linkedToAllBuildingsField"
                 type="checkbox"/>
          <label for="linkedToAllBuildingsField">
            {{ Localization.LinkedToAllBuildings | translate }}
          </label>
        </div>

        <ng-container *ngIf="!team.isLinkedToAllBuildings">
          <chapps-select-input [bindValue]="null"
                               [control]="buildingSelectionField"
                               [items]="availableBuildings"
                               [loading]="operations.loadBuildings.busy"
                               [placeholder]="Localization.SelectBuilding"
          ></chapps-select-input>

          <chapps-primary-button (click)="addSelectedBuilding()"
                                 [disabled]="!buildingSelectionField.value"
                                 [label]="Localization.AddBuilding"
                                 [outline]="true"
                                 [small]="true"
                                 icon="fa-plus"></chapps-primary-button>
        </ng-container>
      </hgroup>

      <table *ngIf="!team.isLinkedToAllBuildings"
             class="table table-striped table-hover details-table">
        <thead>
        <tr>
          <th [translate]="Localization.Label"></th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr (click)="showBuilding(building)"
            *ngFor="let building of teamBuildings"
            class="clickable">
          <td>{{ building.label }}</td>
          <td class="controls">
            <i (click)="removeBuilding(building, $event)"
               class="fas fa-trash text-danger"></i>
          </td>
        </tr>
        </tbody>
      </table>
    </section>
  </main>
</ng-container>
